import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import Card from './Card';
import { SpendIcon, ImpressionIcon } from './Icons';
const AnalyticSummaryCards = ({ spend, impressions, }) => {
    return (_jsxs(Grid, Object.assign({ container: true, spacing: 6 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 6 }, { children: _jsx(Card, { title: "Total Actually Spend", color: "#E0FFF4", value: `₹ ${spend.toLocaleString('en-IN')}`, Icon: SpendIcon }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 6 }, { children: _jsx(Card, { title: "Total Impressions", color: "#FFF5E0", value: impressions.toLocaleString('en-IN'), Icon: ImpressionIcon }) }))] })));
};
export default AnalyticSummaryCards;
